import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, checked } = useAuth();
    if (!checked)
        return (
            <div data-testid="auth-loading" className="min-h-screen grid place-items-center text-slate-500">
                Checking session…
            </div>
        );
    if (!user || user === false) return <Navigate to="/login" replace />;
    return children;
}
